import { Shield, FileLock2 } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="relative border-t border-white/10 py-10 bg-[#050505]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12 flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <Shield size={14} strokeWidth={1.5} className="text-[#00FF66]" />
          <span className="font-['JetBrains_Mono'] text-[11px] tracking-[0.3em] text-[#F5F5F5]">
            RA_SYS<span className="text-[#00FF66]">.</span> // RICHIE_AKPAN
          </span>
        </div>

        <div className="flex items-center gap-6">
          <a
            data-testid="footer-security-txt"
            href="/.well-known/security.txt"
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 font-['JetBrains_Mono'] text-[10px] tracking-[0.3em] text-[#A1A1AA] hover:text-[#00FF66] transition-colors"
          >
            <FileLock2 size={12} strokeWidth={1.5} />
            security.txt
          </a>
          <div className="font-['JetBrains_Mono'] text-[10px] tracking-[0.3em] text-[#A1A1AA]">
            &copy; {new Date().getFullYear()} // ALL_SIGNALS_ENCRYPTED
          </div>
        </div>
      </div>
    </footer>
  );
}
